import i18n from '@/i18n';

export const SUPPORTED_LOCALES = [
	{
		label: i18n.t('menu.navbar.locale_switcher.english'),
		value: 'en-CA'
	},
	{
		label: i18n.t('menu.navbar.locale_switcher.french'),
		value: 'fr-CA'
	},
	{
		label: i18n.t('menu.navbar.locale_switcher.english_uk'),
		value: 'en-GB'
	}
];

export const PHONE_COUNTRIES: PhoneCountry[] = [
	{ code: 'CA', flag: '🇨🇦', dialCode: '+1', labelKey: 'utils.phone_input.country_ca' },
	{ code: 'US', flag: '🇺🇸', dialCode: '+1', labelKey: 'utils.phone_input.country_us' },
	{ code: 'GB', flag: '🇬🇧', dialCode: '+44', labelKey: 'utils.phone_input.country_gb' },
	{ code: 'OTHER', flag: '🌐', dialCode: '+', labelKey: 'utils.phone_input.country_other' }
];

export const VIEWS = {
	webUserOnly: ['ProfileSettings', 'UserInformation', 'UserPaymentMethods', 'PastOrders'],
	suiteOperatorOnly: ['OperatorEventList', 'OperatorSuiteList', 'SuiteSettings']
};
